var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationTriangle = function SvgExclamationTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.73 19.334c.769 1.333-.197 3-1.733 3H2.002c-1.539 0-2.5-1.67-1.732-3l9.997-17.335c.77-1.333 2.697-1.33 3.465 0zM12 15.75a1.917 1.917 0 1 0 0 3.833 1.917 1.917 0 0 0 0-3.833m-1.82-6.89.31 5.667a.5.5 0 0 0 .498.473h2.023a.5.5 0 0 0 .5-.473l.309-5.666a.5.5 0 0 0-.5-.528h-2.64a.5.5 0 0 0-.5.528"
  }))));
};
export default SvgExclamationTriangle;